import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
const API_BASE_URL = "https://church-backend-48tj.onrender.com";




const storyCards = [
  {
    title: 'Our mission',
    text: 'We exist to create thoughtful spaces where people can grow in faith, serve generously, and feel deeply welcomed.',
    image: 'https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?auto=format&fit=crop&w=900&q=80',
  },
  {
    title: 'Who we serve',
    text: 'Families, students, professionals, and visitors all find a place to belong in our community.',
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=900&q=80',
  },
  {
    title: 'Our promise',
    text: 'Every experience is designed to be clear, caring, and beautiful from the first interaction to the last.',
    image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=900&q=80',
  },
];


function AboutPage() {

     const [pastors,setPastors] = useState([]);
       const [milestones,setMilestones]= useState([]);
         const [cultures,setCultures]=useState([]);
const [expandedPastor, setExpandedPastor] = useState(null);



        const getMilestones = async () => {
          try {
              const response = await fetch(`${API_BASE_URL}/api/milestones`);
      
              if (!response.ok) {
                  throw new Error("Failed to fetch stories");
              }
      
              const data = await response.json();
      
              setMilestones(data);
      
          } catch (err) {
              console.error(err);
          }
      };




        const getPastors = async () => {
          try {
              const response = await fetch(`${API_BASE_URL}/api/pastors`);
      
              if (!response.ok) {
                  throw new Error("Failed to fetch stories");
              }
      
              const data = await response.json();
      
              setPastors(data);
      
          } catch (err) {
              console.error(err);
          }
      };
  



      const getCultures = async () => {
          try {
              const response = await fetch(`${API_BASE_URL}/api/cultures`);
      
              if (!response.ok) {
                  throw new Error("Failed to fetch cultures");
              }
      
              const data = await response.json();
      
              setCultures(data);
      
          } catch (err) {
              console.error(err);
          }
      };
  

      
          
           useEffect(() => {
              // socket live adds
              const socket = io(API_BASE_URL, { transports: ['websocket'] });
              socket.on('connect', () => { /* connected */ });
                     socket.on('getpastor', (prod) => { if (prod) setPastors(prev => [prod, ...prev]); });
                     socket.on('getmilestone', (prod) => { if (prod) setMilestones(prev => [prod, ...prev]); });
                      socket.on('getculture', (prod) => { if (prod) setCultures(prev => [prod, ...prev]); });
                         socket.on('updatepastor', (prod) => { if (prod) setPastors(prev => [prod, ...prev]); });
                     socket.on('updatemilestone', (prod) => { if (prod) setMilestones(prev => [prod, ...prev]); });
                      socket.on('updateculture', (prod) => { if (prod) setCultures(prev => [prod, ...prev]); });
      socket.on('deletemilestone', (id) => {
         setMilestones(prev =>
            prev.filter(item => item._id !== id)
         );
      });
      
      socket.on('deletepastor', (id) => {
         setPastors(prev =>
            prev.filter(item => item._id !== id)
         );
      });

      socket.on('deleteculture', (id) => {
   setCultures(prev =>
      prev.filter(item => item._id !== id)
   );
});
              return () => socket.disconnect();
            }, []);


  return (
    <div className="page-shell">
      <section className="hero-banner hero-banner--compact" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1800&q=80)' }}>
        <div className="hero-overlay" />
        <div className="hero-content container">
      
          <h1>About us.</h1>
          <p>Our church and ministry experience is shaped by hospitality, strong vision, and thoughtful digital storytelling.</p>
        </div>
      </section>






      <section className="about-story">

    <div className="story-header">

        <span>OUR LEADERSHIP</span>

      
        <h2>
            Meet The Pastoral Team
        </h2>

        <p>
            Behind every ministry is a team of devoted servants who
            faithfully shepherd God's people with wisdom, compassion
            and unwavering commitment to Christ.
        </p>

  <p>

                WRC Deliverance Church Kona ya Musa was born
                from a passion to see lives transformed through
                the love of Jesus Christ.

            </p>

            <p>

                What began as a small gathering of believers has
                grown into a vibrant church family where worship,
                discipleship and genuine relationships flourish.

            </p>

            <p>

                Through every season God has remained faithful,
                guiding our church with grace, wisdom and purpose.
                Today we continue to build a community where
                everyone can know Christ, grow in faith and
                discover their calling.

            </p>
    </div>

</section>





<section className="pastoral-team-section">



    <div className="pastoral-grid">

        {pastors.map((pastor) => (

            <div
                className="pastor-card"
                key={pastor.id}
            >

                <div className="pastor-image">

                    <img
                        src={pastor.image}
                        alt={pastor.name}
                    />

                    <div className="pastor-role">

                        {pastor.role}

                    </div>

                </div>

                <div className="pastor-content">

                    <h3>{pastor.name}</h3>

                    <div className="quote-mark">“</div>

                   <p
  className={
    expandedPastor === pastor._id
      ? "story-text expanded"
      : "story-text"
  }
>
  {pastor.message}
</p>

{pastor.message && pastor.message.length > 100 && (
  <button
    className="read-more-btn"
    onClick={() =>
      setExpandedPastor(
        expandedPastor === pastor._id
          ? null
          : pastor._id
      )
    }
  >
    {expandedPastor === pastor._id
      ? "Show Less"
      : "Read More"}
  </button>
)}

                    <div className="pastor-line"></div>

                  
                </div>

            </div>

        ))}

    </div>

</section>





      <section className="section container">
        <div className="section-heading">
          <p className="eyebrow">Our story</p>
          <h2>We combine timeless values with a polished modern presence.</h2>
        </div>
        <div className="card-grid">
          {cultures.map((item) => (
            <article className="card" key={item.title}>
              <img src={item.image} alt={item.title} className="card-image" />
              <div className="card-body">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>


<section className="journey-section-2026">

    <div className="journey-heading">

        <span>OUR JOURNEY</span>

        <h2>

            Milestones Of
            God's Faithfulness

        </h2>

        <p>

            Every season has been marked by God's goodness,
            guiding our church from humble beginnings to a
            growing family of believers.

        </p>

    </div>

    <div className="timeline">

        {milestones.map((item, index) => (

            <div
                key={item.year}
                className={`timeline-item ${index % 2 ? "right" : "left"}`}
            >

                <div className="timeline-content">

                    <span className="timeline-year">

                        {item.year}

                    </span>

                    <h3>{item.title}</h3>

                    <p>{item.description}</p>

                </div>

                <div className="timeline-image">

                    <img
                        src={item.image}
                        alt={item.title}
                    />

                </div>

            </div>

        ))}

        <div className="timeline-future">

            <div className="future-circle">

                ?

            </div>

            <h3>The Next Chapter</h3>

            <p>

                Perhaps God is calling you to become part
                of the next chapter in our story.

            </p>

        </div>

    </div>

</section>


    </div>
  );
}

export default AboutPage;
